<template>
    <div class="workPie">
        <div id="workOrderPie"></div>
        <div class="legendBox">
            <ul>
                <li v-for="(item, index) in pieData" :key="item.name">
                    <div>
                        <i :style="{ background: color[index] }"></i>
                        <span class="title">{{ item.name }}</span>
                    </div>
                    <div>
                        <span >{{ item.ratio|formaterRatio }}%</span>
                        <span>{{ item.value }} 家</span>
                    </div>
                </li>
            </ul>
        </div>
    </div>
</template>
<script>
    import echarts from 'echarts';
    export default {
        props: {
            pieData: Array,
            subtext: String
        },
        data () {
            return {
                pieChart: null,
                color: [
                    '#36B374',
                    '#2283E6',
                    '#FF8C19',
                    '#FF4D4D',
                    '#FFD338',
                    '#AC4FE6',
                    '#f59a8f',
                    '#fdb301',
                    '#57e7ec',
                    '#cf9ef1'
                ],
                totla: 0
            };
        },
        filters: {
            formaterRatio: (val) => {
                if (isNaN(val)) {
                    return 0;
                } else {
                    return val
                }
            }
        },
        watch: {
            pieData: {
                handler (newValue, oldValue) {
                    for (let i = 0; i < newValue.length; i++) {
                        if (oldValue[i] !== newValue[i]) {
                            this.initChart();
                            break;
                        }
                    }
                },
                deep: true
            }
        },
        mounted () {
            this.pieChart = echarts.init(document.getElementById('workOrderPie'));
            this.initChart();
        },
        methods: {
            initChart () {
                this.totla = 0;
                this.pieData.forEach(item => {
                    this.totla += item.value
                });
                let option = {
                    backgroundColor: 'rgba(255,255,255,1)',
                    color: this.color,
                    title: {
                        show: true,
                        text: this.totla,
                        subtext: this.subtext ? this.subtext : '总数(家)',
                        textStyle: {
                            color: 'rgba(51,51,51,1)',
                            fontSize: 24
                        },
                        subtextStyle: {
                            show: this.totla > 0,
                            fontSize: this.subtext ? 9 : 12,
                            color: 'rgba(51,51,51,1)'
                        },
                        textAlign: 'center',
                        x: '52%',
                        y: '38%'
                    },
                    series: [
                        {
                            type: 'pie',
                            clockwise: false, // 饼图的扇区是否是顺时针排布
                            minAngle: 10, // 最小的扇区角度（0 ~ 360）
                            radius: ['50%', '63%'],
                            center: ['55%', '50%'],
                            avoidLabelOverlap: false,
                            hoverAnimation: false, // 控制悬浮动画
                            itemStyle: {
                                // 图形样式
                                normal: {
                                    borderColor: '#ffffff',
                                    borderWidth: 2
                                }
                            },
                            label: {
                                normal: {
                                    show: false
                                },
                                emphasis: {
                                    show: false
                                }
                            },
                            data: this.pieData
                        }
                    ]
                };
                this.pieChart.setOption(option);
            }
        }
    };
</script>
<style lang="less" scope>
.workPie {
    border-radius: 3px;
    height: 200px;
    width: 100%;
    overflow: hidden;
    display: flex;
    background: #fff;
    #workOrderPie {
        width:50%;
        height: 100%;
        box-sizing: border-box;
    }
    .legendBox {
        width: 50%;
        ul {
            height: 100%;
            width: 100%;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            box-sizing: border-box;
            padding-top: 20px;
            li {
                display: flex;
                flex-direction: column;
                width: 100%;
                align-items: left;
                justify-content: flex-start;
                div:nth-child(1) {
                    display: flex;
                    align-items: center;
                    width: 100%;
                    i {
                        display: inline-block;
                        height: 8px;
                        width: 8px;
                        margin-right: 10px;
                    }
                    .title {
                        font-size: 12px;
                        font-weight: 500;
                        color: rgba(51, 51, 51, 1);
                    }
                }

                div:nth-child(2) {
                    margin-top: 8px;
                    padding-left: 18px;
                    width: 100%;
                    margin-bottom: 12px;
                    span:nth-child(1) {
                        font-size: 12px;
                        margin-right: 10px;
                        display: inline-block;
                        font-family: PingFangSC-Regular, PingFang SC;
                        font-weight: 400;
                        width: 48px;
                        color: rgba(102, 102, 102, 1);
                    }
                    span:nth-child(2) {
                        font-size: 12px;
                        display: inline-block;
                        font-family: PingFangSC-Regular, PingFang SC;
                        font-weight: 400;
                        width: 49px;
                        white-space: nowrap;
                        text-align: left;
                        color: rgba(102, 102, 102, 1);
                    }
                }
            }
        }
    }
}
</style>
